import { ConfigService as BaseConfigService } from '@signage-player/shared-logic';
import { OperatingSystem } from '@signage-player/data-store';

export class ConfigService extends BaseConfigService {
  constructor() {
    super(import.meta.env, __APP_VERSION__, '@signage-player/web', 'web');
  }

  public override isWindows(): boolean {
    return this.system === OperatingSystem.Windows;
  }

  public override isLinux(): boolean {
    return this.system === OperatingSystem.Linux;
  }

  protected override detectOperatingSystem(): OperatingSystem {
    if (typeof navigator === 'undefined') return OperatingSystem.Linux;
    const ua = navigator.userAgent;
    if (/Windows/i.test(ua)) return OperatingSystem.Windows;
    return OperatingSystem.Linux;
  }
}

export default ConfigService;
